import { useMediaQuery } from "@material-ui/core";
import React from "react";
import { useSelector } from "react-redux";
import { Route, Redirect, RouteProps } from "react-router";
import { RootState } from "redux/rootReducer";
import Footer from "./Footer";
import MainHeader from "./MainHeader";
import MainHeaderMobile from "./MainHeaderMobile";

interface Props extends RouteProps {
  component:
    | React.LazyExoticComponent<React.ComponentClass<any, any>>
    | React.ComponentClass<any, any>
    | React.FunctionComponent<any>;
  path: string;
}

function PrivateRoute(props: Props) {
  const { component: Component, path } = props;

  const matchesMediaQuery = useMediaQuery("(min-width: 1024px)");

  const hasPermission = useSelector((state: RootState) => state.oidc.data?.AccessToken);

  if (!Boolean(hasPermission)) {
    return <Redirect to="/login" />;
  }

  return (
    <>
      {matchesMediaQuery ? <MainHeader /> : <MainHeaderMobile />}
      <div
        style={{
          margin: 16,
          minHeight: matchesMediaQuery
            ? "calc(100% - 105.4px - 100px - 32px)"
            : "calc(100% - 97.4px - 100px - 32px)",
        }}
      >
        <Route
          exact
          path={path}
          render={(renderProps: RouteProps) => <Component {...renderProps} />}
        />
      </div>
      <Footer />
    </>
  );
}

export default React.memo(PrivateRoute);
